module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/minecraft_central.789a1356.png";